"use client";

import {
  CaretDown,
  CaretUp,
  ArrowLeft,
  Phone,
  User,
  LinkedinLogo,
  WhatsappLogo,
  YoutubeLogo,
} from "@phosphor-icons/react";
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Link from "next/link";

const getCoursePath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/courses/${id}` : null;
};

const socialLinks = {
  whatsappUrl:
    "https://api.whatsapp.com/send/?phone=919220361603&text=Hey%20I%20am%20interested%20in%20one%20of%20your%20course",

  youtubeUrl: "https://www.youtube.com/@SOFAR-Analytics",
};

const MobileMenu = ({ onClose, courses, isLoggedIn, onLogout, isDashboardOrLearn = false }) => {
  const [openDropdown, setOpenDropdown] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const timeout = setTimeout(() => setIsVisible(true), 10);

    return () => {
      document.body.style.overflow = "auto";
      clearTimeout(timeout);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 500);
  };

  const toggleDropdown = (item) => {
    setOpenDropdown(openDropdown === item ? "" : item);
  };

  return (
    <div className="fixed inset-0 bg-opacity-40 z-50">
      <div
        className={`
          fixed  right-0 min-h-screen w-full bg-white z-50 p-6 overflow-y-auto
          transform transition-transform duration-500 ease-in-out
          ${isVisible ? "translate-x-0" : "translate-x-full"}
        `}
      >
        <button onClick={handleClose} className="text-black mb-[72px]">
          <ArrowLeft size={32} />
        </button>

        {!isDashboardOrLearn && (
          <nav className="flex flex-col gap-4 text-black text-[28px]">
            <div
              className={`${
                openDropdown === "courses"
                  ? "border border-gray-100 shadow-md p-[16px] rounded-[8px]"
                  : "border-0 shadow-none p-0"
              }`}
            >
              <button
                onClick={() => toggleDropdown("courses")}
                className={`flex justify-between w-full items-center ${
                  openDropdown === "courses"
                    ? "text-[#08448f] font-bold"
                    : "text-black font-normal"
                }`}
              >
                Courses
                {openDropdown === "courses" ? (
                  <CaretUp size={32} />
                ) : (
                  <CaretDown size={32} />
                )}
              </button>

              <AnimatePresence>
                {openDropdown === "courses" && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.5 }}
                    className="mt-[32px] text-[16px] font-normal flex flex-col gap-[24px] overflow-hidden"
                  >
                    {courses?.map((course, index) => {
                      const coursePath = getCoursePath(course);
                      return (
                        <div key={index}>
                          {coursePath ? (
                            <Link href={coursePath} onClick={handleClose}>
                              {course?.title}
                            </Link>
                          ) : (
                            <span className="opacity-50">{course?.title}</span>
                          )}
                        </div>
                      );
                    })}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <Link href="/blog" onClick={handleClose}>
              Blogs
            </Link>

            <a href="/#about-us" onClick={handleClose}>About Us</a>
            <a href="#">Contact Us</a>
          </nav>
        )}

        <div className="mt-[72px] flex flex-col gap-[24px]">
          {!isDashboardOrLearn && (
            <a
              href="tel:+919220361603"
              className="flex items-center justify-center gap-2 rounded-[4px] border border-primary py-[8px] text-primary"
            >
              <Phone size={20} weight="fill" />
              Call Now
            </a>
          )}
          {isLoggedIn ? (
            <>
              {!isDashboardOrLearn && (
                <Link
                  href="/dashboard"
                  onClick={handleClose}
                  className="border border-primary text-primary rounded-[4px] py-[8px] font-medium text-center"
                >
                  Dashboard
                </Link>
              )}
              <button
                onClick={() => {
                  handleClose();
                  onLogout?.();
                }}
                className="bg-primary text-white flex items-center justify-center gap-2 py-[8px] rounded-[4px]"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                href="/register"
                onClick={handleClose}
                className="border border-primary text-primary rounded-[4px] py-[8px] font-medium text-center"
              >
                Sign Up
              </Link>
              <button onClick={handleClose}>
                <Link href="/login" className="bg-primary text-white flex items-center justify-center gap-2 py-[8px] rounded-[4px]">
                  <User size={24} /> Login
                </Link>
              </button>
            </>
          )}
        </div>

        <div className="mt-8 flex justify-center gap-[54px]">
          <LinkedinLogo size={32} />
          <a
            href={socialLinks.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappLogo size={32} />
          </a>
          <a
            href={socialLinks.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <YoutubeLogo size={32} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
